import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(0.75),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[200],
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
  overflowText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
  },
}));
